export default __webpack_public_path__ + "static/media/arcgis-launch-kit.bc108af4.svg";